import { PersistedStateCheckout } from '~/features/Checkout/apollo/cache'
import { PersistedStateVerificationData } from '~/features/Verification/apollo/cache'

export const PersistedState = {
  ...PersistedStateCheckout,
  ...PersistedStateVerificationData,
} as const

export type PersistedStates = ObjectValues<typeof PersistedState>
